<template>
    <div id="app">
      <yetkidialog ref="yetkidialog"></yetkidialog>
      <tanitimMail ref="tanitimdialog" :servisTipi="2"></tanitimMail>
  
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> Transfer Listesi</v-toolbar-title>
            </v-toolbar>
          </v-flex>
         
  
         
        </v-layout>
      </v-card>
      <v-container fluid="">
        <v-layout row wrap="">

<v-flex xs12 sm4 md2>
  <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
    :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date"
    v-model="date"></tarihcomp>
</v-flex>

<v-flex xs12 sm4 md2>
  <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]"
    v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>
</v-flex>

<v-flex>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="getList()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="!load1">
                      <v-layout align-center="" fill-height>
                        <v-progress-circular indeterminate color="info"></v-progress-circular>
                      </v-layout>
                    </div>
                   
                  </v-layout>
                </v-flex>
</v-layout>
      </v-container>
      <v-container fluid grid-list-sm>
        <v-data-table
          :rows-per-page-items="[100]"
          :headers="headers"
          :items="items"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left">
                <v-icon v-if="props.item.Currency!='' && props.item.Currency!='TRY'">attach_money</v-icon>
              </td>
              <td class="text-xs-left">
                {{ props.item.RecieptDate | dateformat }}
              </td>
              <td class="text-xs-left">
                {{ desingRecieptNumber(props.item.RecieptNumber) }}
              </td>
              <td class="text-xs-left">
                {{ props.item.ReciptType.RecieptTypeName }}
              </td>
              <td class="text-xs-left">
                {{ props.item.Center.CenterName }}
              </td>
              <td class="text-xs-left">
                {{ props.item.TotalDept }}
              </td>
              <td class="text-xs-left">
                {{ props.item.TotalCredit }}
              </td>
              <td class="text-xs-left">
                {{ props.item.ERegistryDocDate | dateformat }}
              </td>
              <td class="text-xs-left">
                {{ props.item.RecieptTitle }}
              </td>
              <td class="text-xs-right">
                <v-btn color="info" @click="git(props.item)" outline fab small>
                  <v-icon>search</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
      <v-snackbar
        :timeout="timeout"
        :top="y === 'top'"
        :bottom="y === 'bottom'"
        :right="x === 'right'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="snackbar"
      >
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{
          $t("Close")
        }}</v-btn>
      </v-snackbar>
      
  
     
    </div>
  </template>
  
  <script>
  import auth from "@/api/auth.js";
  import _ from "underscore";
  import router from "@/router.js";
  import helpers from "@/components/app/customcomp/helpers.js";
  import tarihim from "@/components/app/customcomp/tarihim.vue";
  import parainputevents from "@/components/app/customcomp/parainputevents";
  import yuzdeinput from "@/components/app/customcomp/yuzdeinput";
  import hotelloadingcomp from "@/components/app/customcomp/hotelloadingcomp.vue";
  import tanitimMail from "@/components/app/customcomp/tanitimMail.vue";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import tarihcomp from "@/components/app/customcomp/tarihim"
  //import VueGoogleMaps from "vue2-google-maps"
  
  export default {
    data() {
      return {
        headers:[
        {
          text:"PNR",
          
        },
        {
          text:"Statü",
          
        },
        {
          text:"Tedarikçi",
          
        },
        {
          text:"Ad",
          
        },
        {
          text:"Soyad",
          
        },
        {
          text:"Nereden",
          
        },
        {
          text:"Nereye",
          
        },
        {
          text:"Ana Fiyat",
          
        },
        {
          text:"Vergiler",
          
        },
        {
          text:"Markup",
          
        },
        {
          text:"Toplam",
          
        },
        ],
        load1:true,
        date:null,
        date2:null,
        rules: {
          required: (value) => !!value || this.$t("Mandatory-Areas"),
        },
        yetkidialog: false,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        SessionId:'',
        SessionToken:'',
        pagenumber: 1,
        sayfalama: 1,
        paginationDisabled: false,
        vmodelpagination: false,
        islemTipi: null,
        loadingdialog: false,
        validform: true,
        progress: true,
        Time: "",
        search: "",
        search2: "",
        Azalt: false,
       
        menu: false,
        yetiskinSayi: 1,
        cocukSayi: 0,
        bebekSayi: 0,
        transferaditems: [],
        transferbirakaditems: [],
        alinisitems: [],
        birakilisitems: [],
        transferitems: [],
        markupitems: [
          {
            text: this.$t("Percentage"),
            value: "PT",
          },
          {
            text: this.$t("Amount"),
            value: "PC-1",
          },
        ],
      
        LocationInput: {
          Text: null,
          Id: 0,
        },
        siralamatipiitems: [
          {
            text: this.$t("Price-Ascending"),
            value: "Price",
          },
          {
            text: this.$t("Price-Descending"),
            value: "PriceDesc",
          },
        ],
        kuritems: [
          {
            text: "TRY",
            vakye: "TRY",
          },
          {
            text: "EUR",
            value: "EUR",
          },
          {
            text: "USD",
            value: "USD",
          },
          {
            text: "GBP",
            value: "GBP",
          },
        ],
        aramaYapildimi: false,
        aramaYapildimiBirak: false,
        kayitvarmi: false,
        kayitsayi: 0,
        clipped: true,
        drawer: true,
        fixed: false,
        right: true,
        dialog: false,
        loginstatus: true,
        drawer: null,
        text1: "",
        snackbar: false,
        loading: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        confirm: null,
        Credential: {
          email: "",
          password: "",
        },
        valid: true,
      };
    },
    props: {
      source: String,
    },
     mounted() {
      alert('1');
      this.login();
     
    },
    methods: {
     
      login()
      {
        
        this.loadingvmodel = true;
        var params = {
          Username: "Arkgsa",
    Password: "3paPVcsbbpf5Lwj",
    IsTest: true
  
        };
  
        this.$http
          .post( auth.BOOKING_API_URL + "Login", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          })
          .then(
            (response) => {
           
             this.SessionId=response.body.SessionId;
             this.SessionToken=response.body.SessionToken;
             
             window.localStorage.setItem(
              "transferBookingParams",
              JSON.stringify(response.body)
            );

              this.loadingvmodel = false;

console.log(response.body.SessionId);
console.log(response.body.SessionToken);

            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable";
                this.loadingvmodel = false;
                this.snackbar = true;
              } else {
                this.text1 = "Service Unavailable";
                this.loadingvmodel = false;
                this.snackbar = true;
              }
            }
          );
      },
      getImgUrl(pet) {
      return "https://partner.paxdrive.com" + pet;
      
    },
     
      getparabirimi() {
        return ""; // helpers.getparabirimi()
      },
    
     getList()
     {
      var bookingParams = JSON.parse(
          window.localStorage.getItem("transferBookingParams")
        );
        var params={
        SessionHeader:{
      SessionId: bookingParams.SessionId,
      SessionToken:bookingParams.SessionToken
    },
    InsertStartDate :"2025-05-01T00:00:00",
    InsertEndDate : "2025-05-31T00:00:00",
    Status:"PreBooked",
    ProviderType :"Transfer",
    TopTake: false
        }

        this.$http
    .post(auth.BOOKING_API_URL + "Report/Reservations", params, {
      
    })
    
     
     
     
    },
    
    
   
  },
   filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      timeformat: function (c) {
        return helpers.timeformat(c);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
    },
  components: {
      tarihim,
      parainputevents,
      yuzdeinput,
      hotelloadingcomp,
      tanitimMail,
      yetkidialog,
      tarihcomp
    },
};
  
  
  </script>
  
  <style scoped>
  .responsive {
    max-width: 100%;
    height: auto;
  }
  </style>